import type { WebhookRegistration } from '@hangar/shared';
import { formatDateTime } from '@/lib/format';
import { StatusPill } from '@/components/badges';
import { webhookLook } from './webhookStatusModel';

/** Hangar's webhook at the provider: a small pill, what it means for builds, and the reason when it was skipped or failed. */
export function WebhookStatus({ webhook, provider }: { webhook: WebhookRegistration | null | undefined; provider: 'EAS' | 'Bitrise' }) {
  const look = webhookLook(webhook, provider);
  return (
    <div className="flex min-w-0 flex-col gap-1" data-testid="webhook-status" data-state={look.state}>
      <StatusPill status={look.pill} label={look.label} className="w-fit" />
      <p className="text-xs text-muted-foreground">
        {look.note}
        {look.at ? <span className="text-subtle"> · {formatDateTime(look.at)}</span> : null}
      </p>
      {look.reason ? (
        <p className="break-words font-mono text-xs text-subtle" data-testid="webhook-reason">
          {look.reason}
        </p>
      ) : null}
    </div>
  );
}
